import Fetch, { V1 } from 'Util/fetcher';

//= ======================================================================================//
//                                            GET LIST WATCHLIST MF                       //
//= ======================================================================================//

const ON_GET_WATCHLIST_MF = 'ON_GET_WATCHLIST_MF';
const ON_GET_WATCHLIST_MF_SUCCESS = 'ON_GET_WATCHLIST_MF_SUCCESS';
const ON_GET_WATCHLIST_MF_FAILURE = 'ON_GET_WATCHLIST_MF_FAILURE';

function onGetWatchlistMF() {
  return {
    type: ON_GET_WATCHLIST_MF,
  };
}

function onGetWatchlistMFSuccess(payload) {
  return {
    type: ON_GET_WATCHLIST_MF_SUCCESS,
    payload,
  };
}

function onGetWatchlistMFFailure(payload) {
  return {
    type: ON_GET_WATCHLIST_MF_FAILURE,
    payload,
  };
}
export const onDoGetWatchlistMF = () => (dispatch) => {
  dispatch(onGetWatchlistMF());
  Fetch.get(`${V1}mutualfund/fund-bundle/watchlist/?page=1&page_size=30`)
    .then((resp) => {
      if (resp.ok) {
        dispatch(onGetWatchlistMFSuccess(resp.json));
      } else {
        dispatch(onGetWatchlistMFFailure(resp.json));
      }
    })
    .catch((error) => {
      dispatch(onGetWatchlistMFFailure(error.message));
    });
};

//= ======================================================================================//
//                                                 ADD TO WATCHLIST                       //
//= ======================================================================================//

const ON_ADD_WATCHLIST = 'ON_ADD_WATCHLIST';
const ON_ADD_WATCHLIST_SUCCESS = 'ON_ADD_WATCHLIST_SUCCESS';
const ON_ADD_WATCHLIST_FAILURE = 'ON_ADD_WATCHLIST_FAILURE';

function onAddWatchlist() {
  return {
    type: ON_ADD_WATCHLIST,
  };
}

function onAddWatchlistSuccess(payload) {
  return {
    type: ON_ADD_WATCHLIST_SUCCESS,
    payload,
  };
}

function onAddWatchlistFailure(payload) {
  return {
    type: ON_ADD_WATCHLIST_FAILURE,
    payload,
  };
}

export const onDoAddWatchlist = payload => (dispatch) => {
  dispatch(onAddWatchlist());
  Fetch.post(`${V1}funds/watchlist/`, payload)
    .then((resp) => {
      if (resp.ok) {
        dispatch(onAddWatchlistSuccess(resp.json));
      } else {
        dispatch(onAddWatchlistFailure(resp.json));
      }
    })
    .catch((error) => {
      console.log('error');
      dispatch(onAddWatchlistFailure(error.message));
    });
};

//= ======================================================================================//
//                                                 REMOVE FROM WATCHLIST                  //
//= ======================================================================================//

const ON_REMOVE_WATCHLIST = 'ON_REMOVE_WATCHLIST';
const ON_REMOVE_WATCHLIST_SUCCESS = 'ON_REMOVE_WATCHLIST_SUCCESS';
const ON_REMOVE_WATCHLIST_FAILURE = 'ON_REMOVE_WATCHLIST_FAILURE';

function onRemoveWatchlist() {
  return {
    type: ON_REMOVE_WATCHLIST,
  };
}

function onRemoveWatchlistSuccess() {
  return {
    type: ON_REMOVE_WATCHLIST_SUCCESS,
  };
}

function onRemoveWatchlistFailure(payload) {
  return {
    type: ON_REMOVE_WATCHLIST_FAILURE,
    payload,
  };
}
export const onDoRemoveWatchlist = payload => (dispatch) => {
  dispatch(onRemoveWatchlist());
  Fetch.delete(`${V1}funds/watchlist/${payload}/`)
    .then((resp) => {
      if (resp.ok) {
        dispatch(onRemoveWatchlistSuccess());
      } else {
        dispatch(onRemoveWatchlistFailure(resp.json));
      }
    })
    .catch((error) => {
      dispatch(onRemoveWatchlistFailure(error.message));
    });
};

const INITIAL_STATE = {
  watchlistData: null,
  watchlistLoading: null,
  watchlistError: null,

  addWatchlistLoading: null,
  addWatchlistSuccess: null,
  addWatchlistError: null,

  removeWatchlistLoading: null,
  removeWatchlistSuccess: null,
  removeWatchlistError: null,
};

const mfwatchlist = (state = INITIAL_STATE, action = {}) => {
  switch (action.type) {
    // GET
    case ON_GET_WATCHLIST_MF:
      return {
        ...state,
        watchlistData: null,
        watchlistLoading: true,
        watchlistError: null,
      };
    case ON_GET_WATCHLIST_MF_SUCCESS:
      return {
        ...state,
        watchlistData: action.payload,
        watchlistLoading: false,
        watchlistError: null,
      };
    case ON_GET_WATCHLIST_MF_FAILURE:
      return {
        ...state,
        watchlistData: null,
        watchlistLoading: false,
        watchlistError: action.payload,
      };
    // ADD WATCHLIST
    case ON_ADD_WATCHLIST:
      return {
        ...state,
        addWatchlistLoading: true,
        addWatchlistSuccess: null,
        addWatchlistError: null,
      };
    case ON_ADD_WATCHLIST_SUCCESS:
      return {
        ...state,
        addWatchlistLoading: false,
        addWatchlistSuccess: true,
        addWatchlistError: null,
      };
    case ON_ADD_WATCHLIST_FAILURE:
      return {
        ...state,
        addWatchlistLoading: false,
        addWatchlistSuccess: null,
        addWatchlistError: true,
      };

    // REMOVE WATCHLIST
    case ON_REMOVE_WATCHLIST:
      return {
        ...state,
        removeWatchlistLoading: true,
        removeWatchlistSuccess: null,
        removeWatchlistError: null,
      };
    case ON_REMOVE_WATCHLIST_SUCCESS:
      return {
        ...state,
        removeWatchlistLoading: false,
        removeWatchlistSuccess: true,
        removeWatchlistError: null,
      };
    case ON_REMOVE_WATCHLIST_FAILURE:
      return {
        ...state,
        removeWatchlistLoading: false,
        removeWatchlistSuccess: false,
        removeWatchlistError: action.payload,
      };
    default:
      return state;
  }
};

export default mfwatchlist;
